// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main[data-v-5f8ccc38] {\n  width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  min-width: 1200px;\n}\nd .mine_body[data-v-5f8ccc38] {\n  align-items: flex-start;\n}\n.flex[data-v-5f8ccc38] {\n  display: flex;\n  align-items: top;\n}\n.flex_item[data-v-5f8ccc38] {\n  flex: 1;\n  min-width: 0;\n}\n", ""]);
// Exports
module.exports = exports;
